import { render } from "./FooterItem.vue?vue&type=template&id=f1c955ac&scoped=true"
import script from "./FooterItem.vue?vue&type=script&lang=js"
export * from "./FooterItem.vue?vue&type=script&lang=js"

import "./FooterItem.vue?vue&type=style&index=0&id=f1c955ac&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1c955ac"]])

export default __exports__